import { Box, Container } from '@mui/material';
import { useGlobals } from 'src/shared/contexts/appContext';

const PageContainer = ({ children }) => {
  const { systemMessage } = useGlobals();
  return (
    <Box
      component='main'
      role='main'
      sx={{
        flexGrow: 1,
        height: systemMessage ? `calc(100vh - ${systemMessage.height}px)` : '100vh',
        overflowY: 'scroll',
        overflowX: 'auto',
        backgroundColor: 'background.default',
        mt: systemMessage ? `${systemMessage.height}px` : 0,
      }}
    >
      <Container
        maxWidth='xl'
        sx={{
          pt: 10,
          pb: 6,
          md: {
            pt: 8,
          },
          xs: {
            px: 1,
          },
          px: {
            xl: 6,
            lg: 6,
          },
        }}
      >
        {children}
      </Container>
    </Box>
  );
};

export default PageContainer;
